<template>
    <div class="container text-left">
      <div class="row">
        <div class="col-12">
          <h2>구매/배송 대행</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            개인 또는 기업이 한국에서 영국 제품이나 인접 유럽국가에서 제품을 직접구매 한 후 SELLER 가 국제운송 서비스가 불가능하거나 운송비가 너무 비싼 경우 항공 또는 해상 CONSOLIDATION TYPE 의 저렴한 서비스를 이용하실 수 있습니다. 신청서 작성과 동시에 제품의 사이즈(가로 세로 높이)와 중량을 기입하면 항공 또는 해상 운임 및 운송기간을 비교 하실 수 있습니다.

          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            해외상품 직접구매 후 유코쉬핑 창고로 배송신청 – 배송대행 신청서 작성(프린터물 참조)
            SELLER 의 조건이 CASH ON COLLECTION 인 경우 유코쉬핑에서 대행 가능 – 구매대행 신청서
            작성(구매대행의 경우 소액의 수수료가 발생합니다)

          </p>
          <p>
            제품이 당사 물류창고에 입고 되면 제품의 내품상태 및 재포장 유무 사이즈와 무게 확인 후 운송비 견적 제공 – 고객(사) CONFIRM 후 – 운송비 결재 –
            제품 선적 – 제품 선적 후 TRACKING 제공

          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary">구매/배송대행 신청하기</button>
        </div>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Buyer Name
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Order No
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Brand
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Model
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Quantity
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Value
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Weight
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Dim(Size)
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          Tracking No
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          제품 URL
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          포장상태
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          제품사진
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          도착지 주소 (최종 도착지)
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          도착지 TEL
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          운송수단
        </label>
        <select class="col-9 form-control">
          <option value="air">항공</option>
          <option value="ocean">해상</option>
        </select>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          EST DEL DATE
        </label>
        <input type="date" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          INCO TERMS
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
      <div class="row">
        <label class="col-3 form-control">
          관부가세(예상금액)
        </label>
        <input type="text" class="col-9 form-control"/>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Agent",
        data() {
          return {
            item: false,
          }
        }
    }
</script>

<style scoped>
label.form-control {
  border: none;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Agent.vue